import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import FontIcon from 'components/FontIcon';
import classNames from 'classnames';
import Slider from 'react-slick';
import classes from './HeroList.module.scss';

const {
  array,
  arrayOf,
  bool,
  func,
  object,
  shape,
  string,
} = PropTypes;

const ArrowButton = ({
  isNext,
  className,
  style,
  onClick,
}) => (
  <button
    className={className}
    style={style}
    onClick={onClick}
    aria-label={isNext ? 'Next' : 'Previous'}
    type='button'
  >
    <FontIcon
      icon={isNext ? 'far fa-angle-right' : 'far fa-angle-left'}
      className={classNames('fa-4x', classes.arrow)}
    />
  </button>
);

ArrowButton.propTypes = {
  isNext: bool,
  className: string,
  style: object,
  onClick: func,
};

class HeroList extends Component {
  constructor() {
    super();

    this.state = { loaded: false };
  }

  componentDidMount() {
    // This is required to keep the carousel from appearing when
    // rendered on the server.
    this.setState({ loaded: true }); // eslint-disable-line react/no-did-mount-set-state
  }

  render() {
    const { items: slides = [] } = this.props;
    const { loaded } = this.state;
    const autoplaySpeed = 10;

    const containerStyle = loaded ? { visibility: 'visible' } : {};

    if (slides.length === 1) return BuildChildren(slides[0]);

    return (
      <div className={classes.container} style={containerStyle}>
        <Slider
          // used loaded because {typeof window !== 'undefined'} was not working for some reason
          infinite={loaded}
          dots
          speed={500}
          autoplay
          autoplaySpeed={autoplaySpeed * 1000}
          prevArrow={<ArrowButton />}
          nextArrow={<ArrowButton isNext />}
          pauseOnHover
          slidesToShow={1}
          slidesToScroll={1}
        >
          {slides.map((slide) => BuildChildren(slide))}
        </Slider>
      </div>
    );
  }
}

const HeroT = shape({
  heading: string,
  contentMarkup: string,
  backgroundImageUrl: string,
  buttons: array,
  isH1: bool,
});

HeroList.propTypes = {
  /**
   * A list of Heroes
  */
  items: arrayOf(HeroT),
};

export default HeroList;
